// @flow
import React from 'react';
import { Link } from 'react-router';
import { Row, Col, Image, Button } from 'react-bootstrap';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { LinkContainer } from 'react-router-bootstrap';
import {
  Marker,
  Target,
  MagnifyingGlass,
  Mail,
  Lock
} from '../../components/Icons';
import editcampaign from '../../images/edit-campaign.png';
import showcampaign from '../../images/show-campaign.png';
import copycampaign from '../../images/copy-campaign.png';
import fuzzyFilterFactory from 'react-fuzzy-filter';
import PaginatedList from '../../components/PaginatedList';
import SidebarFilterBox from '../../components/SidebarFilterBox';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';

import MomentLocaleUtils, {
  formatDate,
  parseDate
} from 'react-day-picker/moment';
// type Props = {
//   cloneCampaign: Function
// };

const Icon = props => {
  let icon;
  switch (props.status) {
    default:
    case 1:
      icon = <MagnifyingGlass height="24px" />;
      break;
    case 2:
      icon = <Marker height="32px" />;
      break;
    case 3:
      icon = <Target height="30px" />;
      break;
    case 4:
      icon = <Mail height="30px" />;
      break;
    case 5:
      icon = <Lock height="30px" />;
      break;
  }
  return <div className="icon">{icon}</div>;
};

type Props = {
  currentOrgId: any,
  params: {
    campaignId: any,
    context: any
  },
  campaigns: any,
  getCampaigns: Function,
  getCampaignsWithDetail: Function,
  cloneCampaign: Function
};

type State = {
  showArchived: boolean,
  filterValue: string,
  currentItemName?: Object
};

export default class CampaignSidebar extends React.Component<Props, State> {
  fuzzyFilterFactory: any;
  screenReaderContent: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      showArchived: false,
      filterValue: ''
    };
    this.fuzzyFilterFactory = fuzzyFilterFactory();
  }

  componentDidMount() {
    const organisationId = this.props.currentOrgId;
    var context = this.props.params.context;
    switch (context) {
      case 'global':
        this.props.getCampaignsWithDetail(organisationId);
        break;
      default:
      case 'customer':
      case 'sub-account':
        this.props.getCampaigns(organisationId);
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    // currentOrganisation or currentLocation has changed
    if (
      nextProps.params.context !== 'global' &&
      this.props.currentOrgId !== nextProps.currentOrgId
    ) {
      this.getCampaigns(nextProps.currentOrgId, nextProps.params.context);
    }
  }

  getCampaigns = (props: Props, context: string) => {
    const organisationId = props.currentOrgId;
    switch (context) {
      case 'global':
        this.props.getCampaigns(organisationId);
        break;
      default:
      case 'customer':
      case 'sub-account':
        this.props.getCampaigns(organisationId);
    }
  };

  updateFilterValue = (filterValue: ?string) => {
    this.setState({ filterValue: filterValue || '' });
  };

  moveFocusToHeading = (item: Object) => {
    this.setState({ currentItemName: item.name }, () =>
      this.screenReaderContent.focus()
    );
  };

  downloadCampaigns = () => {
    let csvContent = '';
    const headersArray = [];
    const downloadableCampaigns = [];

    headersArray.push('Organisation Id');
    headersArray.push('Organisation Name');
    headersArray.push('Sub-Organisation Id');
    headersArray.push('Sub-Organisation Name');
    headersArray.push('Campaign Name');
    headersArray.push('Date Created');
    headersArray.push('Date Updated');
    headersArray.push('Status');
    headersArray.push('Booked Date');
    headersArray.push('ABN');
    headersArray.push('UM Locked');
    headersArray.push('AM Locked');
    headersArray.push('Is Locked');
    headersArray.push('Is Archived');
    headersArray.push('Catchment Method');
    headersArray.push('Target Type');
    headersArray.push('Created By');
    headersArray.push('Organisation Type');
    headersArray.push('Address');
    headersArray.push('Campaign ID');
    headersArray.push('Booking Id');
    headersArray.push('Booking Number');
    headersArray.push('Include Do Not Mail Addressed');
    headersArray.push('Include No Junk Mail Addressed');
    headersArray.push('Include No Junk Mail Unaddressed');
    headersArray.push('Insight Set Id');
    headersArray.push('Insight Set Name');

    downloadableCampaigns[0] = headersArray;
    for (let i = 0; i < this.props.campaigns.length; i++) {
      const tempCampaignRowArray = [];
      if (this.props.campaigns[i]['parentId']) {
        tempCampaignRowArray.push(this.props.campaigns[i]['parentId']);
        tempCampaignRowArray.push(
          '"' + this.props.campaigns[i]['parentName'] + '"'
        );
        tempCampaignRowArray.push(this.props.campaigns[i]['organisationId']);
        tempCampaignRowArray.push(
          '"' + this.props.campaigns[i]['organisationName'] + '"'
        );
      } else {
        tempCampaignRowArray.push(this.props.campaigns[i]['organisationId']);
        tempCampaignRowArray.push(
          '"' + this.props.campaigns[i]['organisationName'] + '"'
        );
        tempCampaignRowArray.push('');
        tempCampaignRowArray.push('');
      }
      tempCampaignRowArray.push('"' + this.props.campaigns[i]['name'] + '"');
      tempCampaignRowArray.push(
        moment(this.props.campaigns[i]['dateCreated']).format('DD/MM/YYYY')
      );
      tempCampaignRowArray.push(
        moment(this.props.campaigns[i]['dateUpdated']).format('DD/MM/YYYY')
      );
      tempCampaignRowArray.push(this.props.campaigns[i]['statusName']);
      tempCampaignRowArray.push(
        this.props.campaigns[i]['bookedDate']
          ? moment(this.props.campaigns[i]['bookedDate']).format('DD/MM/YYYY')
          : ''
      );
      tempCampaignRowArray.push(this.props.campaigns[i]['organisationAbn']);
      tempCampaignRowArray.push(this.props.campaigns[i]['umLocked']);
      tempCampaignRowArray.push(this.props.campaigns[i]['amLocked']);
      tempCampaignRowArray.push(this.props.campaigns[i]['isLocked']);
      tempCampaignRowArray.push(this.props.campaigns[i]['isArchived']);
      tempCampaignRowArray.push(
        this.props.campaigns[i]['catchmentMethod']
          ? '"' + this.props.campaigns[i]['catchmentMethod'] + '"'
          : ''
      );
      tempCampaignRowArray.push(
        this.props.campaigns[i]['campaignTargetTypeName']
          ? '"' + this.props.campaigns[i]['campaignTargetTypeName'] + '"'
          : ''
      );
      tempCampaignRowArray.push(this.props.campaigns[i]['createdBy']);
      tempCampaignRowArray.push(
        this.props.campaigns[i]['organisationTypeName']
      );
      tempCampaignRowArray.push(
        this.props.campaigns[i]['address']
          ? '"' + this.props.campaigns[i]['address'] + '"'
          : ''
      );
      tempCampaignRowArray.push(this.props.campaigns[i]['id']);
      tempCampaignRowArray.push(this.props.campaigns[i]['bookingId']);
      tempCampaignRowArray.push(this.props.campaigns[i]['bookingNumber']);
      tempCampaignRowArray.push(
        this.props.campaigns[i]['includeDoNotMailAcquisition']
      );
      tempCampaignRowArray.push(
        this.props.campaigns[i]['includeNoJunkMailAcquisition']
      );
      tempCampaignRowArray.push(
        this.props.campaigns[i]['includeNoJunkMailUnaddressed']
      );
      tempCampaignRowArray.push(this.props.campaigns[i]['insightSetId']);
      tempCampaignRowArray.push(
        '"' + typeof this.props.campaigns[i]['insightSetName'] !== 'undefined'
          ? this.props.campaigns[i]['insightSetName']
          : '' + '"'
      );
      downloadableCampaigns.push(tempCampaignRowArray);
    }

    downloadableCampaigns.forEach(function(downloadableCampaign) {
      let row = downloadableCampaign.join(',');
      csvContent += row + '\r\n';
    });

    if (!navigator.userAgent.match('CriOS')) {
      const csv = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
      saveAs(csv, 'campaigns.csv');
    } else {
      csvContent = `data:text/csv;charset=utf-8,${csvContent}`;
      let encodedUri = encodeURI(csvContent);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'campaigns.csv');
      if (document.body) {
        document.body.appendChild(link);
      }
      link.click();
      if (document.body) {
        document.body.removeChild(link);
      }
    }
  };

  render() {
    const {
      params: { campaignId = 'new', context },
      currentOrgId,
      campaigns,
      isGlobal
    } = this.props;
    const { datesLoaded } = this.state;
    const LineItem = props => {
      const campaign = props.item;
      if (isGlobal) {
        return (
          <Row
            key={campaign.id}
            className={`sidebar-list-item ${campaign.isArchived &&
              'archived'} tall-list-item`}
          >
            <Link to={`/${context}/${currentOrgId}/campaigns/${campaign.id}/`}>
              <Col
                sm={12}
                // $FlowFixMe
                className={`overflow-ellipsis map-link ${campaignId ===
                  campaign.id.toString() && 'active'}`}
              >
                <span className="campaign-list-icon">
                  <Icon
                    status={campaign.isLocked ? 5 : campaign.statusTypeId}
                  />
                </span>
                <p title={campaign.name}>
                  <strong>{campaign.name}</strong>
                </p>
                <div>
                  <small title={`Created by ${campaign.createdBy}`}>
                    Created by {campaign.createdBy}
                  </small>
                </div>
                <div>
                  <small
                    title={`Updated ${moment(campaign.dateUpdated).format(
                      'DD/MM/YYYY'
                    )}`}
                  >
                    Updated at{' '}
                    {moment(campaign.dateUpdated).format('DD/MM/YYYY')}
                  </small>
                </div>
              </Col>
            </Link>
          </Row>
        );
      } else {
        return (
          <Row
            key={campaign.id}
            className={`sidebar-list-item ${campaign.isArchived &&
              'archived'} tall-list-item`}
          >
            <Link
              to={`/${context}/${currentOrgId}/campaigns/${campaign.id}/map`}
            >
              <Col
                sm={10}
                // $FlowFixMe
                className={`overflow-ellipsis map-link ${campaignId ===
                  campaign.id.toString() && 'active'}`}
              >
                <span className="campaign-list-icon">
                  <Icon
                    status={campaign.isLocked ? 5 : campaign.statusTypeId}
                  />
                </span>
                <p title={campaign.name}>
                  <strong>{campaign.name}</strong>
                </p>
                <div>
                  <small title={`Created by ${campaign.createdBy}`}>
                    Created by {campaign.createdBy}
                  </small>
                </div>
                <div>
                  <small
                    title={`Updated ${moment(campaign.dateUpdated).format(
                      'DD/MM/YYYY'
                    )}`}
                  >
                    Updated at{' '}
                    {moment(campaign.dateUpdated).format('DD/MM/YYYY')}
                  </small>
                </div>
              </Col>
            </Link>

            <Col
              sm={2}
              className="edit-btn text-center campaign-edit-link campaign-list-tall"
            >
              <Row>
                <Link
                  to={`/${context}/${currentOrgId}/campaigns/${campaign.id}`}
                  onClick={e => this.moveFocusToHeading(campaign)}
                >
                  <Col sm={12}>
                    <Image
                      src={campaign.isLocked ? showcampaign : editcampaign}
                      responsive
                      alt="Edit Campaign"
                    />
                    <span className="campaign-edit-link-text">
                      {campaign.isLocked ? 'View' : 'Edit'}
                    </span>
                  </Col>
                </Link>
              </Row>
              <Row
                onClick={e => this.props.cloneCampaign(campaign)}
                className="campaign__clone-row"
              >
                <Col sm={12}>
                  <Image src={copycampaign} responsive alt="Copy Clone" />
                  <span className="campaign-edit-link-text">Copy</span>
                </Col>
              </Row>
            </Col>
          </Row>
        );
      }
    };

    return (
      <div className="generic-sidebar">
        <Row>
          <Col sm={12} md={6}>
            <h3
              className="screen-reader-only"
              tabIndex="-1"
              ref={i => (this.screenReaderContent = i)}
            >
              Editing campaign {this.state.currentItemName}
            </h3>
            <h1>Campaigns</h1>
          </Col>
          <Col sm={12} md={6}>
            {!isGlobal && (
              <LinkContainer to={`/${context}/${currentOrgId}/campaigns/new`}>
                <Button bsStyle="primary" className="new-btn">
                  Create New
                </Button>
              </LinkContainer>
            )}
          </Col>

          <Col sm={12} md={12} lg={12}>
            <SidebarFilterBox
              onChange={this.updateFilterValue}
              fuzzyFilterFactory={this.fuzzyFilterFactory}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            {campaigns && campaigns.length > 0 && (
              <PaginatedList
                filterValue={this.state.filterValue}
                itemsPerPage={10}
                component={LineItem}
                pageButtonLimit={5}
                items={campaigns.sort(
                  (a, b) => new Date(b.dateUpdated) - new Date(a.dateUpdated)
                )}
                showArchived={this.state.showArchived}
                fuzzyFilterFactory={this.fuzzyFilterFactory}
                keys={['id', 'dateUpdated', 'name', 'createdBy']}
                pluralName="campaigns"
                sortOrder="desc"
              />
            )}
          </Col>
        </Row>
        {!isGlobal && (
          <Row>
            <Col sm={12} md={12} lg={12} className="show-archived-wrapper">
              <div className="checkbox-wrapper">
                <input
                  type="checkbox"
                  name="archiveCheckbox"
                  id="archiveCheckbox"
                  className="archive-checkbox"
                  checked={this.state.showArchived}
                  onChange={() =>
                    this.setState({ showArchived: !this.state.showArchived })
                  }
                />
                <label htmlFor="archiveCheckbox" className="checkbox-label">
                  Show Archived
                </label>
              </div>
            </Col>
          </Row>
        )}
        {context === 'global' && (
          <Row className="campaign-download">
            <Col xs={12}>
              <h1 font>Download Campaigns</h1>
            </Col>
            <Col xs={12}>
              <Button
                className="booking-download__button"
                bsStyle="primary"
                onClick={this.downloadCampaigns}
              >
                Download
              </Button>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/campaigns/CampaignSidebar.js